import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DashboardPage, ModalContentRequestPage, ModalContentAllTimeUpdatePage, ModalContentSickPage, ModalContentirsenTypePage } from './dashboard';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';

@NgModule({
  declarations: [
    DashboardPage,
    ModalContentRequestPage,
    ModalContentAllTimeUpdatePage,
    ModalContentSickPage, 
    ModalContentirsenTypePage
  ],
  imports: [
    IonicPageModule.forChild(DashboardPage),
    CalendarModule,
  ],

  entryComponents: [
    ModalContentRequestPage,
    ModalContentAllTimeUpdatePage,
    ModalContentSickPage,
    ModalContentirsenTypePage
  ],
  providers: [
    RestProvider,
  ]
})
export class DashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.module.ts